import { coreAgent } from "../../app/api/agent";
import { JjisCodeDto } from "./dtos/JjisCodeDto";

export const getJJISCodesRequest = () =>
  coreAgent.getRequest<JjisCodeDto[]>("/jjisPrograms");
